function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "16",
  height: "12",
  viewBox: "0 0 16 12",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M15.633.337a1.138 1.138 0 00-1.616 0L5.535 8.83 1.972 5.255A1.163 1.163 0 10.355 6.929L4.727 11.3a1.138 1.138 0 001.617 0l9.29-9.29a1.138 1.138 0 000-1.673z",
  fill: "currentColor",
  fillRule: "evenodd"
})));